import React from 'react';
import { useRouter } from 'next/navigation';
import Button from '@mui/material/Button';
import JobTitleSearch, { JobOptionType } from './JobTitleSearch';
import { CityOption } from '@/context/city';
import { NATION_WIDE } from '@/constants/city';
import { JOB_TITLE_PAGE_ROUTER_PATH } from '@/constants/router-path';
import { JOB_TITLE_PAGE_CITY_SEARCH_ID } from '@/constants/component-id';
import { trackClickEvent } from '@/utils/site-track';

const SearchArea = () => {
  const [jobValue, setJobValue] = React.useState<JobOptionType>({
    id: '',
    name: '',
    nameType: 'primary',
    aliasId: '',
  });
  const [cityValue, setCityValue] = React.useState<CityOption | undefined>({
    id: '',
    name: '',
    pinyin: '',
  });
  const router = useRouter();

  const handleJobChange = (val: JobOptionType) => setJobValue(val);

  const handleCityChange = (val: CityOption | undefined) => setCityValue(val);

  const onSearch = (e: React.MouseEvent<HTMLButtonElement>) => {
    trackClickEvent(e);
    if (jobValue) {
      const id =
        jobValue.nameType === 'alias' && jobValue.aliasId
          ? jobValue.aliasId
          : jobValue.id;
      const prefixUrl =
        cityValue?.id === NATION_WIDE.id
          ? JOB_TITLE_PAGE_ROUTER_PATH
          : `/${cityValue?.pinyin}/`;
      const query =
        jobValue.nameType === 'alias' && jobValue.aliasId === null
          ? jobValue?.name
          : null;
      router.push(`${prefixUrl}${id}${query ? `?jn=${query}` : '/'}`);
    }
  };

  return (
    <>
      <div className="w-full flex items-center mb-16 pb-1.5">
        <JobTitleSearch
          jnClassName="flex-1 mr-4"
          jobValue={jobValue}
          cityValue={cityValue}
          handleChange={handleJobChange}
          handleCityChange={handleCityChange}
          pageUniqueId={JOB_TITLE_PAGE_CITY_SEARCH_ID}
        />
        <Button
          className="!w-18 !h-12 !rounded-lg !ml-5"
          variant="contained"
          onClick={onSearch}
          data-ele-id="button"
          data-ele-group="search_button"
          data-observer-id="search_button"
        >
          查询
        </Button>
      </div>
    </>
  );
};

export default SearchArea;
